import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

import Home from './components/Home';
import About from './components/About';
import Contents from './components/Contents';
import Exam from './components/Exam';
import Footer from './components/Footer';


function App() {
    const nextSchedules = [
        {
            id: 1,
            schedule: '10. - 15. April 2025'
        },
    ];
    return (
            <div className="App">
                <Home />
                <About />
                <Contents />
                <Exam nextSchedules={nextSchedules}/>
                <Footer />
            </div>
            );
}

export default App;
